enum Audience {
  ANONYMOUS = "anonymous",
  AUTHENTICATED = "authenticated",
  VISITOR = "visitor",
  SPECIALIST = "specialist",
  MODERATOR = "moderator",
  ADMIN = "admin",
}

export default Audience;
